module.exports = "/assets/site/images/MVM_tennis.jpg?04439d340252e51ba82b8bad20d43311";